import * as React from "react";
import { Card, CardContent, Box, Typography, Grid, Tooltip } from "@mui/material";
import { Title } from "react-admin";
import { RANKS } from "../points/ranks"; // <- muss exportieren: [{ name, threshold, ... }]
import { getRankBadge } from "../config/rankBadges";

export default function RanksOverviewPage() {
  return (
    <Box sx={{ p: { xs: 1, sm: 2 } }}>
      <Title title="Ränge" />
      <Typography variant="h5" sx={{ fontWeight: 900, mb: 1 }}>
        Rang-Übersicht
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Alle Badges und die jeweiligen Punkte-Schwellen.
      </Typography>

      <Grid container spacing={2}>
        {[...RANKS]
          .sort((a: any, b: any) => (a.threshold ?? 0) - (b.threshold ?? 0))
          .map((r: any) => {
            const b = getRankBadge(r.name);
            return (
              <Grid item xs={6} sm={4} md={3} key={r.name}>
                <Card sx={{ height: "100%" }}>
                  <CardContent sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <Tooltip title={r.name}>
                      <Box
                        component="img"
                        src={b.icon}
                        alt={b.label ?? r.name}
                        sx={{
                          width: 48,
                          height: 48,
                          filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.35))",
                          flexShrink: 0,
                        }}
                      />
                    </Tooltip>

                    <Box sx={{ minWidth: 0 }}>
                      <Typography sx={{ fontWeight: 900, lineHeight: 1.1 }}>
                        {r.name}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        ab {Number(r.threshold ?? 0).toLocaleString("de-DE")} Punkte
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
      </Grid>
    </Box>
  );
}
